module.exports = __webpack_public_path__ + "static/media/dropdown-arrow-grey.b2a524a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dropdown-arrow-grey.svg
// module id = 1090
// module chunks = 1